<template>
    <div class="modal fade share-bet-modal" id="qrShareModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered information-modal-wrapper">
            <div class="modal-content">
                <button v-if="showQrCode" type="button" class="cross_btn_top" data-bs-dismiss="modal" aria-label="Close">&#10006;</button>
                <div class="modal-body">
                    <section class="sub-header-wrapper">
                        <div class="qrPreview-image login-by-social-icon ui-social">
                            <div class="footer-social-bx shared_social_img" v-if="showQrCode">
                                <div>
                                    <figure >
                                        <img class="qrData" loading="lazy" :src="qrCode" alt="QR-Code">
                                    </figure>
                                </div>
                                <div class="ui-social-icon">
                                <div class="f-social-icon">
                                    <a :href="`https://t.me/share/url?url=${qrCode}`" target="_blank">
                                        <img src="@/assets/images/telegram-icon.svg" alt="telegram" loading="lazy" />
                                    </a>
                                </div>
                                <div class="f-social-icon">
                                    <a :href="`https://wa.me/?text=${(qrCode)}`" target="_blank">
                                        <img src="@/assets/images/whatsapp-social.svg" alt="whatsapp" loading="lazy" />
                                    </a>
                                </div>
                                <div class="f-social-icon">
                                    <a href="https://www.instagram.com/" @click="copyImgUrl()" target="_blank">
                                        <img src="@/assets/images/instagram-icon.svg" alt="instagram-icon" loading="lazy" />
                                    </a>
                                </div>
                                <div class="f-social-icon">
                                    <a :href="`https://www.facebook.com/sharer/sharer.php?u=${qrCode}`" target="_blank">
                                        <img loading="lazy" src="@/assets/images/facebook-icon.svg" alt="facebook-icon" />
                                    </a>
                                </div>
                            </div>
                            </div>
                            <div v-else class="modal-footer border-0 feedback-footer w-100">
                                <div class="text-center">
                                    <qrcode-canvas v-if="qrCode" :value="qrCode" level="H" id="qrCanvas" />
                                </div>
                                <div class="qr-change-text">
                                <button class="btn thm-but thm-bor-but feedback-sub-btn share-btn btnWrap" @click="share()">
                                    <img loading="lazy" src="@/assets/images/share.webp" alt="share" />
                                    Share
                                </button>
                                <button class="btnWrap" type="button" data-bs-dismiss="modal" aria-label="Close">Close</button>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { QrcodeCanvas } from 'qrcode.vue'
export default {
    name: 'qrCodeShareModal',
    components:{QrcodeCanvas},
    props: ['qrCode','share','showQrCode'],
    methods:{
        copyImgUrl () {
            const input = document.createElement("textarea");
            input.value = this.qrCode
            document.body.appendChild(input);
            input.select();
            document.execCommand("copy");
            document.body.removeChild(input);
            this.$successToast("Successfully copied.");
        }
    }
}
</script>